import { useState } from 'react';
import axios from 'axios';
import {
  Box,Typography,Button,FormControlLabel,Paper,CircularProgress,Alert,FormControl,InputLabel,MenuItem,
  Select,Radio,RadioGroup,TextField
} from '@mui/material';
import { useMsal } from "@azure/msal-react";
import {baseURL} from "../Constant";
import './Certificates.css';

const Certificates = () => {
  const [file, setFile] = useState(null);
  const [enterpriseID, setEnterpriseID] = useState('');
  const [designation, setDesignation] = useState('');  
  const [category, setCategory] = useState('');
  const [status, setStatus] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [uploadType, setUploadType] = useState('template');

  const categories = ['participation', 'completion', 'achievement'];
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const entID = activeAccount?.idTokenClaims?.enterpriseID;      

  const handleFileChange = (e) => {
    setStatus('');
    setFile(e.target.files[0]);
  }
  const handleCategoryChange = (e) => setCategory(e.target.value);

  const handleChange = (event) => {
    setUploadType(event.target.value);
    setCategory('');
    setFile(null); 
    setEnterpriseID('');
    setDesignation('');   
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file) {
      setStatus('Please select a file.');
      return;
    }

    const formData = new FormData();
    formData.append('uploadType', uploadType);
    formData.append('category', category);
    formData.append('uploaded_by', entID);
    formData.append('enterpriseId', enterpriseID);
    formData.append('designation', designation);    
    formData.append('file', file);    

    try {
      setIsUploading(true);
      setStatus('');
      const response = await axios.post(`${baseURL}/pptx/upload`, formData);           
      setStatus('Uploaded successfully.');
      setTimeout(() => {
        setStatus('');  
      },8000)
      setFile(null);
      setCategory('');
      setEnterpriseID('');
      setDesignation('');
    } catch (err) {
      console.error(err);
      setStatus('Upload failed.');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Box className="upload-container">
      <Paper className="upload-card" elevation={3}>        
        <form onSubmit={handleUpload} className="upload-form">
            <FormControl>              
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={uploadType}
                onChange={handleChange}
                row
                sx={{'justify-content': 'space-evenly'}}
              >
                <FormControlLabel value="template" control={<Radio />} label="Template" />
                <FormControlLabel value="signature" control={<Radio />} label="Signature" />
              </RadioGroup>
            </FormControl>
            {uploadType === 'template' && <FormControl fullWidth required>                                  
                <InputLabel id="category-label">Category</InputLabel>
                <Select
                    labelId="category-label"
                    id="category"
                    value={category}
                    label="Category"
                    onChange={handleCategoryChange}
                    className="input-field"
                >
                    {categories.map((cat) => (
                    <MenuItem key={cat} value={cat}>
                        {cat.charAt(0).toUpperCase() + cat.slice(1)}
                    </MenuItem>
                    ))}
                </Select>
            </FormControl>}
            {uploadType === 'signature' && <TextField
              required
              id="outlined-required"
              label="Enterprise Id"
              value={enterpriseID}
              onChange={e => setEnterpriseID(e.target.value)}                            
            />}
            {uploadType === 'signature' && <TextField
              required
              id="outlined-required"
              label="Designation"                 
              value={designation}
              onChange={e => setDesignation(e.target.value)}                         
            />}
          <Button variant="contained" component="label" className="file-button">
            Choose File
            <input type="file" hidden onChange={handleFileChange} />
          </Button>
          {file && (
            <Typography variant="body2" className="filename">
              📄 {file.name}
            </Typography>
          )}

          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={isUploading}
          >
            {isUploading ? <CircularProgress size={24} /> : 'Upload'}
          </Button>
        </form>

        {status && (
          <Alert severity={status.startsWith('Uploaded') ? 'success' : 'error'} sx={{ mt: 2 }}>
            {status}
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default Certificates;
